import React, { Component } from "react";
import BaseModal, { ModalActions, SaveButton, CancelButton, DeleteButton } from "../../../../containers/UI/Modal/BaseModal";
import InputRow from "../../../configuration/Rows/InputRow/InputRow";
import SelectRow from "../../../configuration/Rows/SelectRow/SelectRow";
import FileRow from "../../../configuration/shared/FileRow/FileRow";
import ButtonRow from "../../../configuration/shared/ButtonRow/ButtonRow";
import CheckboxRow from "../../../configuration/shared/CheckboxRow/CheckboxRow";
import axios from "../../../../axios";


class InvoiceModal extends Component {

  state = {
    invoice: {},
    options: { "Intracommunity": false, "Sent to Poisson": false },
    status: { "Deliverd to customer": false, "Invoice paid": false },
    uploadFile: null,
    valuesChanged: false,
    orderOptions: [],
    selectedFileName: null,
  }

  componentDidMount() {
    let invoice = this.props.selectedInvoice
    // Create an invoice if necessary
    if (invoice === null) {

      // Propose a reference
      let today = new Date()
      let invoiceDate = today.getTime() / 1000

      invoice = { 
        intraCommunity: false, 
        sentToAccountant: false, 
        sentToCustomer: false, 
        paid: false,
        invoiceReference: this.props.proposedIndex + " - " + today.getFullYear().toString().slice(-2) + String(today.getMonth() + 1).padStart(2, '0') + String(today.getDate()).padStart(2, '0') + "01",
        invoiceDate: invoiceDate
      }
    }
    // Change dot to comma
    if (invoice.amountWithoutVAT) {
      invoice.amountWithoutVAT = invoice.amountWithoutVAT.toLocaleString("be-NL")
    }
    // Parse date
    if (invoice.invoiceDate) {
      invoice.invoiceDate = new Date(invoice.invoiceDate * 1000).toLocaleDateString("en-GB")
    }
    if (invoice.dueDate) {
      invoice.dueDate = new Date(invoice.dueDate * 1000).toLocaleDateString("en-GB")
    }

    this.setState({ 
      invoice: {...invoice},
      options: { "Intracommunity": invoice.intraCommunity, "Sent to Poisson": invoice.sentToAccountant },
      status: { "Deliverd to customer": invoice.sentToCustomer, "Invoice paid": invoice.paid },
      orderOptions: invoice.customer ? this.props.orderOptions[invoice.customer._id] ?? [] : []
    })
  }

  deleteHandler = () => {
    // Sync to the backend
    axios.delete("/invoices/delete/" + this.state.invoice._id)
    // Close the modal view
    this.props.closeModal()
  }

  saveInvoiceHandler = () => {

    // Parse additional properties into invoice
    let invoice = this.state.invoice
    invoice.sentToCustomer = this.state.status["Deliverd to customer"]
    invoice.sentToAccountant = this.state.options["Sent to Poisson"]
    invoice.intraCommunity = this.state.options["Intracommunity"]
    invoice.paid = this.state.status["Invoice paid"]
    invoice.amountWithoutVAT = invoice.amountWithoutVAT ? invoice.amountWithoutVAT.replace(/,/g, '.') : null

    // Convert European date to JavaScript date
    var parts = invoice.invoiceDate ? invoice.invoiceDate.split("/") : []
    if (parts.length === 3) {
      var date = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
      invoice.invoiceDate = date.getTime() / 1000
    } else {
      invoice.invoiceDate = 0
    }

    // Sync to the backend
    if (this.state.valuesChanged) {
      axios.post("/invoices/update/verkoop", this.state.invoice)
    }

    // Close the modal view
    this.props.closeModal()
  }

  /**
   * Parse sales invoice filename to extract reference and invoice date
   * Expected format: "INDEX - YYMMDDXX CUSTOMER" (e.g., "81 - 25121501 MCS")
   */
  parseSalesFilename = (filename) => {
    try {
      // Remove .pdf extension
      const baseName = filename.replace(/\.pdf$/i, '').replace(/\s*\(\d+\)$/, '').trim()
      
      // Match pattern: INDEX - YYMMDDXX CUSTOMER
      const match = baseName.match(/^(\d+)\s*-\s*(\d{8})(?:\s+.*)?$/)
      
      if (match) {
        const [, index, dateCode] = match
        const reference = `${index} - ${dateCode}`
        
        // Parse date from YYMMDDXX format
        const year = parseInt(dateCode.substring(0, 2), 10)
        const month = parseInt(dateCode.substring(2, 4), 10)
        const day = parseInt(dateCode.substring(4, 6), 10)
        
        // Validate date parts
        if (month < 1 || month > 12 || day < 1 || day > 31) {
          return null
        }
        
        // Format invoice date as DD/MM/YYYY
        const invoiceDate = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/20${String(year).padStart(2, '0')}`
        
        return {
          reference,
          invoiceDate
        }
      }
    } catch (e) {
      console.warn('Could not parse sales invoice filename:', filename, e)
    }
    return null
  }

  uploadPDF = (event, thisRef) => {
    const file = event.target.files[0]
    if (!file) return

    // Track the selected filename for visual feedback
    thisRef.setState({ selectedFileName: file.name })

    // In create mode, try to parse filename for autofill
    const createMode = thisRef.props.selectedInvoice === null
    
    if (createMode) {
      const parsed = thisRef.parseSalesFilename(file.name)
      
      if (parsed) {
        // Autofill reference and invoice date (user can still edit)
        thisRef.setState(prevState => ({
          invoice: {
            ...prevState.invoice,
            invoiceReference: parsed.reference,
            invoiceDate: parsed.invoiceDate
          },
          valuesChanged: true
        }))
      }
    }

    // Read the file's contents
    var reader = new FileReader();
    reader.addEventListener("load", function() {
      // Save uploaded PDF
      let pdfContent = reader.result.split("base64,")[1]
      thisRef.updateProperty("pdfContent", pdfContent)
    })
    reader.readAsDataURL(file)
  }

  downloadPDFhandler = () => {

    // Request the PDF from the backend first (lazy fetch)
    axios.get("/invoices/pdf/" + this.state.invoice._id).then(response => {
      if (response.data) {

        if (response.data.pdfContent) {
          // Download PDF file
          const fileName = this.state.invoice.invoiceReference + ".pdf"
          const href = "data:application/pdf;base64," + response.data.pdfContent
          const link = document.createElement("a")
          link.href = href
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          return 

        } 
      }
      alert("No PDF file was attached to this invoice entry.")

    }).catch((err) => {
      alert("Could not download invoice: " + err.message)
    })
  }

  updateProperty(property, value) {
    let newState = { invoice: {...this.state.invoice}, valuesChanged: true }
    newState.invoice[property] = value

    if (property === "customer") {
      // Reset order and update order options if customer changes
      newState.orderOptions = this.props.orderOptions[value._id] ?? []
      newState.invoice.order = []
    }

    // Update state
    this.setState(newState)
  }


  render() {

    let createMode = (this.props.selectedInvoice === null)

    // Calculate total amount with VAT
    let showTotal = false
    let totalAmount = 0
    if (this.state.invoice.amountWithoutVAT) {
      let numericWithoutVAT = this.state.invoice.amountWithoutVAT.replace(/,/g, '.')
      if (!isNaN(numericWithoutVAT)) {
        if (this.state.options.Intracommunity) {
          totalAmount = parseFloat(numericWithoutVAT)
        } else {
          totalAmount = Math.round(parseFloat(numericWithoutVAT) * 121) / 100
        }
        showTotal = true
      } else {
        showTotal = false
      }
    }

    // Calculate and show dueDate based on invoiceDate
    let showDueDate = false
    let dueDateDisplay = ""
    
    if (this.state.invoice.invoiceDate) {
      const parts = this.state.invoice.invoiceDate.split("/")
      if (parts.length === 3) {
        const invoiceDate = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10))
        if (!isNaN(invoiceDate.getTime())) {
          const dueDate = new Date(invoiceDate.getTime() + (30 * 24 * 60 * 60 * 1000))
          dueDateDisplay = dueDate.toLocaleDateString("en-GB")
          showDueDate = true
        }
      }
    }


    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title={createMode ? "Upload new invoice" : "Edit invoice"}
      >
        <SelectRow
          title="Customer"
          firstRow
          ultrawide
          value={this.state.invoice.customer ? (this.state.invoice.customer._id ?? "") : ""}
          onChange={(newValue) => this.updateProperty("customer", { _id: newValue.value })}
          options={this.props.customersOptions}/>
        <SelectRow
          title="Order"
          firstRow
          ultrawide
          isMulti
          value={this.state.invoice.order}
          onChange={(valueArray) => this.updateProperty("order", valueArray.map(option => option.value))}
          options={this.state.orderOptions}/>
        <InputRow
          title="Reference"
          enabled
          ultrawide
          value={this.state.invoice.invoiceReference ?? ""}
          placeholder={"E.g. 1 - 2024011501"}
          onChange={(event) => this.updateProperty("invoiceReference", event.target.value)}/>
        <InputRow
          title="Invoice date"
          enabled
          ultrawide
          value={this.state.invoice.invoiceDate ?? ""}
          placeholder={"E.g. 15/01/2024"}
          onChange={(event) => this.updateProperty("invoiceDate", event.target.value)}/>
        {showDueDate &&
        <InputRow
          title="Due date"
          enabled={false}
          ultrawide
          value={dueDateDisplay}/>}
        <InputRow
          title="Amount excl. VAT"
          enabled
          ultrawide
          value={this.state.invoice.amountWithoutVAT ?? ""}
          placeholder={"Amount"}
          onChange={(event) => this.updateProperty("amountWithoutVAT", event.target.value)}/>
        {showTotal &&
        <InputRow
          title="Total invoice amount"
          enabled={false}
          ultrawide
          value={"€ " + totalAmount.toLocaleString("de-DE")}/>}
        <CheckboxRow
          title="Options"
          options={this.state.options}
          optionChanged={(option, checked) => {
            let options = {...this.state.options}
            options[option] = checked
            this.setState({ options: options, valuesChanged: true })
          }}/>
        <CheckboxRow
          title="Status"
          options={this.state.status}
          optionChanged={(option, checked) => {
            let status = {...this.state.status}
            status[option] = checked
            this.setState({ status: status, valuesChanged: true })
          }}/> 

        {!createMode &&
        <ButtonRow
          title="Download invoice PDF"
          ultrawide
          body="Download .pdf file"
          onClick={this.downloadPDFhandler}/>}

        <FileRow
          title={createMode ? "Upload invoice PDF" : "Replace invoice PDF"}
          body={"Choose .pdf file"}
          inputId="salesInvoicePdfInput"
          selectedFileName={this.state.selectedFileName}
          onClick={(pdf) => this.uploadPDF(pdf, this)}
          extension=".pdf"/>

        <ModalActions>
          {(this.state.valuesChanged || createMode) ? (
            <>
              <CancelButton onClick={this.props.closeModal}/>
              {!createMode && <DeleteButton onClick={this.deleteHandler}/>}
              <SaveButton onClick={this.saveInvoiceHandler}>
                {createMode ? "Upload" : "Save"}
              </SaveButton>
            </>
          ) : (
            <>
              <CancelButton onClick={this.saveInvoiceHandler}>Close</CancelButton>
              <DeleteButton onClick={this.deleteHandler}/>
            </>
          )}
        </ModalActions>
      </BaseModal>
    );
  }
}

export default InvoiceModal;
